import { useState } from "react"

export const useExpanded = (init = false) => {
    const [expandedId, setExpandedId] = useState(init)

    const toggleExpanded = id => {
        if(expandedId === id) {
            setExpandedId(false)
        } else {
            setExpandedId(id)
        }
    }

    return [expandedId, toggleExpanded]
}